import * as angular from 'angular';
import {IController} from "angular";

export class ReportsViewCtrl implements IController {
  from: any;
  to: any;

  private stateCurrentName: any;
  private sisenseOpen: any;
  private deliveriesOpen: any;
  private performanceOpen: any;
  private effectivenessOpen: any;
  private billingOpen: any;
  private performanceDeliveriesCompletionOpen: any;
  private performanceTasksAccuracyOpen: any;
  private performanceRoutesAccuracyOpen: boolean;
  private performanceRushHoursOpen: any;
  private performanceServiceAreasOpen: any;
  private effectivenessTimeBasedActivityOpen: any;
  private effectivenessServiceTimeActivityOpen: any;

  public isSideMenuOpen: boolean;


  /* @ngInject */
  constructor(private $state) {

  }

  $onInit() {
    this.stateCurrentName = this.$state.current.name;

    // ******************************
    //        Main Views Open
    // ******************************

    this.sisenseOpen = this.stateCurrentName.match('sisense');
    this.deliveriesOpen = this.stateCurrentName.match('deliveries');
    this.performanceOpen = this.stateCurrentName.match('performance');
    this.effectivenessOpen = this.stateCurrentName.match('effectiveness');
    this.billingOpen = this.stateCurrentName.match('billing');

    // ******************************
    //        Sub Views Open
    // ******************************

    // Performance
    this.performanceDeliveriesCompletionOpen = this.stateCurrentName.match('deliveries-completion');
    this.performanceTasksAccuracyOpen = this.stateCurrentName.match('tasks-accuracy');
    this.performanceRushHoursOpen = this.stateCurrentName.match('rush-hours');
    this.performanceServiceAreasOpen = this.stateCurrentName.match('service-area');

    // Effectiveness
    this.effectivenessTimeBasedActivityOpen = this.stateCurrentName.match('time-based-activity');
    this.effectivenessServiceTimeActivityOpen = this.stateCurrentName.match('service-time-activity');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onPerformanceClicked() {
    this.performanceOpen = !this.performanceOpen;

    if (!this.performanceOpen) {
      this.performanceDeliveriesCompletionOpen = false;
      this.performanceTasksAccuracyOpen = false;
      this.performanceRushHoursOpen = false;
      this.performanceServiceAreasOpen = false;
    }
  }

  onEffectivenessClicked() {
    this.effectivenessOpen = !this.effectivenessOpen;

    if (!this.effectivenessOpen) {
      this.effectivenessTimeBasedActivityOpen = false;
      this.effectivenessServiceTimeActivityOpen = false;
    }
  }

}

angular
  .module('bringoz.admin.reports')
  .component('reportsView', {
    bindings: {
      from: '<',
      to: '<'
    },
    template: require('./reports-view.html').default,
    controller: ReportsViewCtrl
  });
